import { SxProps, Theme } from '@mui/system';
import { Box } from '../../MuiGenerals';

const closeBtnStyle: SxProps<Theme> = {
  position: 'absolute',
  top: '8px',
  right: '8px',
  color: '#7a7b7e',
  fontSize: '12px',
  cursor: 'pointer',
};

interface IProps {
  sx?: SxProps<Theme>;
  handleClick: () => void;
}

const CloseBtn = ({ sx, handleClick }: IProps) => {
  return (
    <Box sx={{ ...closeBtnStyle, ...sx }} onClick={handleClick}>
      X
    </Box>
  );
};

export default CloseBtn;
